import React from 'react';
import { lmsItemsPriority } from '../../../../constants';
import { lmsStatusChips } from '../../../../utils/utils';
interface Props {
  data: any;
}
function GeneralInfo({ data }: Props) {
  
  function getPriorityLabel(value: any) {
    const priority = lmsItemsPriority.find(p => p.value === value);
    return priority ? priority.label : value;
  }

  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>General Info</h5>
      </div>
      <div className='card-body pt-2 p-4 h-auto'>
      <div className='row'>
          <div className='col-md-6'>
            <span className='global-text-16'>Lot no. (Barcode)</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.barcode ? data?.barcode : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Created by</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.created_By ? data?.created_By : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Freight type</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.freight_type ? data?.freight_type : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Customer name</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.customer_name ? data?.customer_name : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Origin</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.origin_location_code ? data?.origin_location_code : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Destination</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.destination_location_code ? data?.destination_location_code : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Priority</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {lmsStatusChips(getPriorityLabel(data?.priority))}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Consigned to</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.consigned_to_name ? data?.consigned_to_name : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Point of origin</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.point_of_origin ? data?.point_of_origin : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Camp Container Name</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.camp_container_name ? data?.camp_container_name : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Yard Location</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.yard_location ? data?.yard_location : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Subcontractor Name</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.subcontractor_name ? data?.subcontractor_name : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Vehicle Type</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.vehicle_type ? data?.vehicle_type : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Label</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.label ? data?.label : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>No of Labels</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.no_of_Labels ? data?.no_of_Labels : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>External Document no.</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.external_document_no ? data?.external_document_no : 'N/A'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GeneralInfo;
